import {
  coreApiUrl,
  CREDIT_LINE_FAQ_URLS,
  CREDY_TERMS_PAGE_URLS,
  customerProfileUrl,
  FAQ_URLS,
  HOMEPAGE_CREDIT_LINE_PAGE_URLS,
  HOMEPAGE_REGION_URL,
  newCustomerProfileUrl,
  PRIVACY_POLICY_URL,
  TERMS_PAGE_URLS,
} from 'environment';

import { AppLanguages } from './app.constants';

export const REDIRECT_URLS = {
  newCustomerProfile: newCustomerProfileUrl,
  newCustomerProfileCreditLine: `${newCustomerProfileUrl}/credit-line`,
  newCustomerProfileCreditAccountModification: `${newCustomerProfileUrl}/ca-modification`,
  creditAccountWithdrawal: `${newCustomerProfileUrl}/credit-account-withdrawal`,
  incomeInsurance: `${newCustomerProfileUrl}/insurance`,
  incomeInsuranceTerms: `${coreApiUrl}/insurance/download-service-terms?locale=:locale`,
  incomeInsuranceDataPolicy: {
    [AppLanguages.en]:
      'https://seesam.ee/en/information/processing-of-personal-data',
    [AppLanguages.et]: 'https://seesam.ee/et/teave/isikuandmete-tootlemine',
    [AppLanguages.ru]:
      'https://seesam.ee/ru/informaciya/obrabotka-personalnyh-dannyh',
    [AppLanguages.lv]:
      'https://seesam.ee/en/information/processing-of-personal-data',
    [AppLanguages.lt]:
      'https://seesam.ee/en/information/processing-of-personal-data',
  },
  customerProfile: customerProfileUrl,
  customerProfileCreditLineOnboarding: `${customerProfileUrl}/#getCredit`,
  customerProfileSubscription: `${customerProfileUrl}/pay/subscription`,
  customerProfileApplication: `${customerProfileUrl}/pay/application`,
  newCustomerProfileInvoicePayment: `${newCustomerProfileUrl}/payment/invoice`,
  frequentlyAskedQuestionsPageUrls: FAQ_URLS,
  creditLineFrequentlyAskedQuestionsPageUrls: CREDIT_LINE_FAQ_URLS,
  termsPageUrs: TERMS_PAGE_URLS,
  credyTermsPageUrs: CREDY_TERMS_PAGE_URLS,
  homepageCreditLinePageUrls: HOMEPAGE_CREDIT_LINE_PAGE_URLS,
  homepageRegionUrl: HOMEPAGE_REGION_URL,
  privacyPolicy: PRIVACY_POLICY_URL,
};
